import { render, staticRenderFns } from "./Subheading.vue?vue&type=template&id=0d27c712&"
import script from "./Subheading.vue?vue&type=script&lang=ts&"
export * from "./Subheading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports